import { HFlex, VFlex } from '../../../components/FlexContainers';
import { Link, styled } from '@mui/material';
import { palette } from '../../../theme/palette';

export const Root = styled(VFlex)`
  margin: 0 auto;
  gap: 0px;
  margin-bottom: 15px;
`;

export const AnchorLink = styled(Link)`
  letter-spacing: 0.35px;
  color: ${palette.custom.darkGrey};
  margin-bottom: 0px;
  width: fit-content;
  text-decoration: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 5px;
  transition: all 0.3s ease;
  line-height: 1.75rem;
  :hover {
    background-color: ${palette.custom.lightGrey};
    padding: 5px 15px;
  }
`;

export const LoaderContainer = styled(HFlex)`
  min-height: 40px;
  align-items: center;
  padding-left: 40px;
`;
